<template>
  <v-scale-transition origin="center center 0 ">
    <div class="journeyChangeEnd" v-if="journeyDialog">
      <v-card
        tile
        flat
        color="white"
        width="100vw"
        style="
          height: calc(100vh + 15px);
          background-color: rgba(255, 255, 255, 0.7) !important;
        "
      >
        <v-row class="fill-height" :align="$vuetify.breakpoint.mdAndUp ? 'center' : 'start'" justify="center">
          <v-col cols="12" md="8" class="px-0" style="position: relative">
            <!-- Desktop -->
            <TheJourneyChangeDesktop :journey="journeyArray[0]" @click="close()" @send="close()" v-if="journey.etapa === 'explorando' && $vuetify.breakpoint.mdAndUp" />
            <TheJourneyChangeDesktop :journey="journeyArray[1]" @click="close()" @send="send(1)" v-if="journey.etapa === 'descobrindo' && $vuetify.breakpoint.mdAndUp" />
            <TheJourneyChangeDesktop :journey="journeyArray[2]" @click="close()" @send="send(2)" v-if="journey.etapa === 'experimentando' && $vuetify.breakpoint.mdAndUp" />
            <TheJourneyChangeDesktop :journey="journeyArray[3]" @click="close()" @send="send(3)" v-if="journey.etapa === 'escolhendo' && $vuetify.breakpoint.mdAndUp" />
            <!-- Mobile -->
            <TheJourneyChangeMobile :journey="journeyArray[0]" @click="close()" @send="close()" v-if="journey.etapa === 'explorando' && !$vuetify.breakpoint.mdAndUp" />
            <TheJourneyChangeMobile :journey="journeyArray[1]" @click="close()" @send="send(1)" v-if="journey.etapa === 'descobrindo' && !$vuetify.breakpoint.mdAndUp" />
            <TheJourneyChangeMobile :journey="journeyArray[2]" @click="close()" @send="send(2)" v-if="journey.etapa === 'experimentando' && !$vuetify.breakpoint.mdAndUp" />
            <TheJourneyChangeMobile :journey="journeyArray[3]" @click="close()" @send="send(3)" v-if="journey.etapa === 'escolhendo' && !$vuetify.breakpoint.mdAndUp" />
          </v-col>
        </v-row>
      </v-card>
    </div>
  </v-scale-transition>
</template>

<script>
import { mapState } from 'vuex'
import TheJourneyChangeMobile from '@/components/TheJourneyChangeMobile'
import TheJourneyChangeDesktop from '@/components/TheJourneyChangeDesktop'

export default {
  components: {
    TheJourneyChangeMobile,
    TheJourneyChangeDesktop,
  },
  computed: {
    ...mapState(['journeyDialog', 'journey']),
  },
  data: () => ({
    message: [
      '',
      {
        text: 'Separamos uma surpresa pra você. Acesse sua jornada e veja o que você ganhou!',
        button: 'Ir para jornada',
      },
      { text: 'Preparamos recompensas para você. Vem ver!', button: 'Ver 👀' },
      {
        text: 'Vem ver as recompensas que preparamos para essa etapa da jornada:',
        button: 'Ver recompensas',
      },
    ],
    journeyArray: [
      {
        name: 'explorando',
        image: 'etapa1.png',
        image2: 'changeJourneyD1.png',
        topText: 'Que feliz, você embarcou nessa com a gente! :)',
        bottomText: 'Aqui, quanto mais você explora, mais avança – tanto na sua jornada, quanto nas oportunidades que estão por aí.',
        button: 'Vamos lá!',
      },
      {
        name: 'descobrindo',
        image: 'etapa2.png',
        image2: 'changeJourneyD2.png',
        topText: `Uhuul! Você desbloqueou a etapa "Descobrindo"`,
        bottomText: 'Por aqui, nós adoramos descobrir novas possibilidades. Vamos juntos?',
        button: 'Vamos lá 🔍!',
      },
      {
        name: 'experimentando',
        image: 'etapa3.png',
        image2: 'changeJourneyD3.png',
        topText: 'Agora a etapa Experimentando está disponível.',
        bottomText: ' Só experimentando a gente descobre se gosta de algo.',
        button: 'Experimentar',
      },
      {
        name: 'escolhendo',
        image: 'etapa4.png',
        image2: 'changeJourneyD4.png',
        topText: 'Agora a etapa Escolhendo está disponível. É hora de parar para pensar no que você já viveu!',
        bottomText: 'Reveja os conteúdos que mais curtiu, com certeza eles irão te ajudar ;) Mas também preparamos novidades. Venha com a gente!',
        button: 'Me ajuda a escolher!',
      },
    ],
  }),
  methods: {
    close() {
      this.$store.dispatch('setJourneyDialogInfo', null)
    },
    send(lvl = 0) {
      this.$store.dispatch('setErrorInfo', {
        open: true,
        text: this.message[lvl].text,
        button: this.message[lvl].button,
        route: '/jornada#' + this.journeyArray[lvl - 1].name,
      })
      this.close()
    },
  },
}
</script>

<style>
.journeyChangeEnd {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-shadow: unset !important;
}

.jorneyChangeImage {
  z-index: 1001 !important;
  position: relative;
}

.jcmobile {
  /* margin-top: -40px; */
  width: 950%;
  height: 90%;
  max-height: calc(90% - 160px);
  max-width: 95%;
  margin: 0 auto;
  overflow-y: unset !important;
}

.jorneyLetsGo {
  position: absolute;
  width: 80%;
  max-width: 700px;
  bottom: -50px;
  left: 10%;
  right: 0%;
}

.jorneyLetsGoMobile {
  position: absolute;
  bottom: -45px;
  z-index: 500;
  margin-left: -140px;
  width: 280px !important;
  left: 50%;
  font-size: 0.8em !important;
}

.jcboxMobile {
  margin-top: -50px !important;
  max-width: 220px;
  margin: 0 auto;
  z-index: 500;
  color: #ffffff !important;
}

.jcbox {
  max-width: 300px;
  position: absolute;
  top: 5%;
  right: 15%;
  z-index: 500;
  color: #ffffff !important;
}

.jcboxEnd {
  margin-top: 48px;
  position: relative;
  z-index: 1;
}

.jcboxContent {
  z-index: 120 !important;
  background: #ff55a6;
}

.jcboxEndBackground {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 10px;
  top: 10px;
  background: #502d7c;
  z-index: -20;
}

.jcboxEndRecompensa {
  color: #502d7c !important;
  font-family: 'DM Sans' !important;
  font-size: 16px !important;
  font-weight: bold !important;
  letter-spacing: 0 !important;
  line-height: 21px !important;
}
</style>
